export var RecipeIngredientType;
(function (RecipeIngredientType) {
    RecipeIngredientType["INGREDIENT"] = "ingredient";
    RecipeIngredientType["RECIPE"] = "recipe";
})(RecipeIngredientType || (RecipeIngredientType = {}));
export const defaultRecipeIngredient = {
    id: 'new',
    type: 'ingredient',
    pricePerProduction: 0,
    quantityPerProduction: 0,
};
export const defaultRecipeData = {
    name: '',
    categories: [],
    allergens: [],
    productionTime: '',
    pvp: 0,
    servingsPerProduction: 1,
    priceVariation: 0,
    productionAmount: 0,
    inMenu: false,
    ingredients: [],
    ingredientIds: [],
    preparation: {
        prePreparation: [],
        preparation: [],
        conservation: [],
    },
    image: '',
    productionCost: 0,
    unit: 'ud',
};
//# sourceMappingURL=RecipeEntity.js.map